<div cdkTrapFocus class="find-sample-modal-wrapper">
  <div class="modal-close-container">
    <button id="close-modal-cross-btn" type="button" class="close pull-right btn-close-modal" aria-label="Close"
            (click)="modalRef.hide()"
            (keydown.enter)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-header">
      <h3 id="modal-header-title" class="modal-title" i18n="@@FindSampleModalTitle">Find Options</h3>
      <p id="modal-header-subtitle"  class="modal-subtitle" i18n="@@findSampleModalSubtitle">A menu labelled <i>Find</i> will be appear on the Reference Details and Reference Editor panes.</p>
  </div>
  <div class="modal-body">
    <p>Reference Details pane</p>
    <img class="preview-pane-img" src="assets/images/find-preview-pane.png" alt="Reference Details pane" i18n-alt="@@FindPreviewPaneAltText"/>
    <p>Reference Editor pane</p>
    <img class="ref-editor-img" src="assets/images/find-ref-editor.png" alt="Reference Editor pane" i18n-alt="@@FindRefEditorAltText"/>
  </div>
</div>
